<script>
import { computed, defineComponent, watch } from '@vue/composition-api';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';

export default defineComponent({
  props: {
    stores: {
      type: Array,
      default: () => [],
    },
    changeStoreSelected: {
      type: Function,
      default: () => () => {},
    },
    storeSelected: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { root }) {
    const stores = computed(() => props.stores);
    const loading = computed(() => props.loading);
    const { changeStoreSelected } = props;

    const sellerStores = computed(() => {
      if (!loading.value) {
        const allStores = {
          default: true,
          name: 'Todas as Lojas',
          id: [...stores.value.map((el) => el.id)],
        };
        const mappedStores = stores.value.map((el) => ({ ...el, id: [el.id] }));
        if (mappedStores.length === 1) return [...mappedStores];
        return [allStores, ...mappedStores];
      }
      return [];
    });

    watch(
      sellerStores,
      () => {
        if (sellerStores.value) {
          if (sellerStores.value.length === 1) {
            // eslint-disable-next-line prefer-destructuring
            changeStoreSelected(sellerStores.value[0]);
          } else {
            changeStoreSelected(sellerStores.value.find((el) => !!el.default));
          }
        }
      },
      { immediate: true },
    );

    return {
      sellerStores,
    };
  },
});
</script>
<template>
  <div class="stores">
    <v-autocomplete
      :value="storeSelected"
      :items="sellerStores"
      :loading="loading"
      color="primary"
      item-text="name"
      placeholder="Buscar..."
      return-object
      @change="changeStoreSelected"
    >
      <template slot="label">
        <strong class="stores__label">Escolher Loja:</strong>
      </template>
    </v-autocomplete>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .v-input input {
    max-height: 40px !important;
}
.stores__label {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
::v-deep .v-input {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
}
.stores {
  margin-top: 20pt;
  margin-bottom: 20pt;
    &__label {
      font-size: 12pt;
      color: black;
      font-weight: 500;
    }
    & .v-input input {
      max-height: 40px !important;
    }
  }
</style>
